import React from "react";
import { OKCancel } from "../../../../../common-deprecated/components/modals/aem/lexus/ModalActionViews";
import ModalBaseView from "../../../../../common-deprecated/components/modals/aem/lexus/ModalBaseView";
import type { CompareV2DispatchType } from "../../../redux/store";
import { useCompareV2Selector } from "../../../redux/store";
import { compareRemoveCar } from "../../../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";
import { CompareV2Label, useCompareV2Label } from "../../../utils/labels";
import type { DeleteCarType } from "../../../../../shared-logic/features/compare/utils/modalConstants";
import * as Modal from "../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Text from "../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import * as Type from "../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { trackCompareGradeRemove } from "../../../utils/tracking";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const LexusDeleteCarModal = (props: ModalViewType<DeleteCarType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { indexToDelete } = modalSettings;

    const newCars = useCompareV2Selector((state) => state.newCarCompare.grades || []);

    const dispatch = useDispatch<CompareV2DispatchType>();

    const labelParts = useCompareV2Label("compareModalDeleteCar").split("{carToDelete}");
    const showLabel = !!newCars[indexToDelete].modelName;
    const [compareModalRemoveButtonLabel, compareModalCancelButtonLabel] = useCompareV2Label([
        "compareModalRemoveButton",
        "compareModalCancelButton",
    ]);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header buttonAlignment="left">
                <Modal.Button type="button" onClick={close} lightBg hasText>
                    <IconWrapper>
                        <Icon variant="arrowLeft" />
                    </IconWrapper>
                    <Text.Button>
                        <CompareV2Label label="compareSelectBack" />
                    </Text.Button>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                {showLabel && (
                    <Type.Text headingType="base">
                        {labelParts[0] || ""}
                        <Type.Text headingType="base" styleType="headline">
                            {`${newCars[indexToDelete].modelName} ${newCars[indexToDelete].gradeName} ${newCars[indexToDelete].bodyTypeName}`}
                        </Type.Text>
                        {labelParts[1] || ""}
                    </Type.Text>
                )}
            </Modal.Body>
            <OKCancel
                onApprove={() => {
                    trackCompareGradeRemove(newCars[indexToDelete]);
                    dispatch(compareRemoveCar(indexToDelete));
                    close();
                }}
                approveLabel={compareModalRemoveButtonLabel}
                onCancel={close}
                cancelLabel={compareModalCancelButtonLabel}
            />
        </ModalBaseView>
    );
};

export default LexusDeleteCarModal;
